import { dontAwait } from "@glideapps/ts-necessities";
import { asBoolean } from "common/components/component-helpers";
import { LOADING, ActionSource } from "common/components/types";
import { GlideFunctionalRenderer } from "common/components/uis";
import Checkbox from "../ui/smart/checkbox/checkbox";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";
import { useEditComponentEnabledViaNetworkStatus } from "hooks/use-edit-components-enabled-via-network-status";

export const CheckboxAccessoryMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[value, onChangeValue, isEnabledValue], [valueProducer]] = useForceValueProducers(
        getValueProducers,
        force,
        ctx
    );
    const [editingAllowed] = useEditComponentEnabledViaNetworkStatus(env);
    const { onClick: onChangeCB } = useOnClickFromAction(onChangeValue, ActionSource.Switch, ctx, env);

    if (value === LOADING) return null;

    const isEnabled = editingAllowed && (onChangeCB === undefined || isEnabledValue !== false);

    const onChange = (newValue: boolean): void => {
        if (valueProducer === undefined) return;

        valueProducer.set(newValue);
        if (onChangeCB !== undefined) {
            dontAwait(onChangeCB(undefined));
        }
    };

    return <Checkbox checked={asBoolean(value)} onChanged={onChange} isEnabled={isEnabled} />;
};
